import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import { useLocation } from "react-router-dom";
// import Login from "../pages/login/Login";
import OvcNewLogin from "../pages/newLogin/Login";
import { FloatingComponentProvider } from "../component/floating-component-context/FloatingComponentContext";
// import SlidingPanel from "react-sliding-side-panel";
import OVCAPIService from "../service/ovc-service";
import axios from "axios";
import Notifcation from "../component/Notification/Notifcation";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Sidebar = lazy(() => import("../component/sidebar/Sidebar"));
const Template = lazy(() => import("../pages/template/Template"));
const CreateTemplate = lazy(() => import("../pages/template/CreateTemplate"));
const Segment = lazy(() => import("../pages/segments/Segment"));
const CreateSegment = lazy(() => import("../pages/segments/CreateSegment"));
const Workflow = lazy(() => import("../pages/workflows/Workflow"));
const CreateWorkFlow = lazy(() => import("../pages/workflows/CreateWorkFlow"));
const UploadSegment = lazy(() => import("../pages/segments/Upload-segment"));
const PreviewTemplate = lazy(() => import("../pages/template/PreviewTemplate"));
const PreviewWorkflow = lazy(
  () => import("../pages/workflows/PreviewWorkflow")
);
const PreviewSegment = lazy(() => import("../pages/segments/PreviewSegment"));
const CustomerProfile = lazy(() => import("../pages/ovc/CustomerProfile"));
const CustomerDetails = lazy(() => import("../pages/ovc/CustomerDetails"));
const LoanDetailsTabs = lazy(() => import("../component/loan-details/LoanDetailsTabs"));
const LoandetailsCustomer = lazy(() => import("../component/loan-details/CustomerLoanDetails"));
const TicketManagement = lazy(() => import("../component/TicketManagement/TicketManagement"));
const OVCDashboard = lazy(() => import("../pages/ovc/OVCDashboard"))
const AutoDialerDashboard = lazy(() => import("../pages/AutoDialer/AutoDialerDashboard"))
const WorkFlowDashboard = lazy(() => import("../pages/workflows/Dashboard/Dashboard"))
const SahogyCustomerList = lazy(() => import("../component/CRM/Sahyog/CustomerList"))
const SahogyCustomerDetails = lazy(() => import("../component/CRM/CustomerDetails/CustomerDetails"));
const BusinessPrimeCustomerList = lazy(() => import("../component/CRM/BusinessPrime/CustomerList"))
const DeviceInventry = lazy(() => import("../component/CRM/BusinessPrime/DeviceInventry"))
const BusinessPrimeDashboard = lazy(() => import("../component/CRM/BusinessPrime/Dashboard/Dashboard"))
const BusinessPrimeBulkUpload = lazy(() => import("../component/CRM/BusinessPrime/BulkUpload"))
const InsuranceCustomerList = lazy(() => import("../component/CRM/Insurance/CustomerList"));
const PostduecollectionList =  lazy(() => import("../component/CRM/Collection/CustomerList"));
const PreduecollectionList =  lazy(() => import("../component/CRM/Collection/CustomerList"));
const InsuranceDashboard = lazy(() => import("../component/CRM/Insurance/Dashboard"));
const SahyogDashboard = lazy(() => import("../component/CRM/Sahyog/Dashboard"));
const SalesWorkflow = lazy(() => import("../component/CRM/SalesWorkflow/CustomerList"));
const WelcomeWorkList  = lazy(() => import("../component/CRM/SalesWorkflow/CustomerInterestList"));
const HotLeadsList  = lazy(() => import("../component/CRM/SalesWorkflow/HotLeadsList"));
const SalesworkflowCustomerDetails  = lazy(() => import("../component/CRM/SalesWorkflow/customerDetails"));
const QueryManagement  = lazy(() => import("../component/TicketManagement/QueryManagement"));
const UserManagement  = lazy(() => import("../component/TicketManagement/UserManagement"));
const UserManagementDashboard  = lazy(() => import("../component/TicketManagement/Dashboard"));
const UploadListInsurance  = lazy(() => import("../component/CRM/Insurance/UploadList"));
const MissedCall  = lazy(() => import("../component/CRM/MissedCall/MissedCall"));
const CETCustomerList  = lazy(() => import("../component/CRM/CET/CustomerList"));
const DigitalLeadsListing  = lazy(() => import("../component/CRM/DigitalLeads/DigitalLeadsListing"));
const DigitalLeadDetails  = lazy(() => import("../component/CRM/DigitalLeadDetails/DigitalLeadDetails"));
const PartnerLeadsListing  = lazy(() => import("../component/CRM/PartnerLeads/PartnerLeadsListing"));

const RedirectBasedOnRole = () => {
  let ovcData = null;
  try {
    ovcData = JSON.parse(localStorage.getItem("ovcData"));
  } catch (e) {}
  const role = ovcData?.role;
  if (!role) return <Navigate to="/" replace />;
  if (["PRODUCT-BP", "PRODUCT-OPERATION-BP"].includes(role)) {
    return <Navigate to="/businessPrime-dashboard" replace />;
  }
  if (["WELFARE-OFFICER", "Welfare officer"].includes(role)) {
    return <Navigate to="/sahyog-dashboard" replace />;
  }
  if (["IN​SURANCE-OFFICER"].includes(role)) {
    return <Navigate to="/insurance-dashboard" replace />;
  }
  if (["PQ", "PQ-POSTDUE", "PQ-PREDUE"].includes(role)) {
    return <Navigate to="/collection-dashboard" replace />;
  }
  if (["CET", "OPERATION-CET"].includes(role)) {
    return <Navigate to="/cet-dashboard" replace />;
  }
  if (["_OPERATION-CSS", "OPERATION-CSS-OUTBOUND" ,"OPERATION-CSS-INBOUND"].includes(role)) {
    return <Navigate to="/sales-dashboard" replace />;
  }
  return <Navigate to="/ticket-dashboard" replace />;
};

const NotificationHandler = () => {
  const location = useLocation(); 
  const ovsService = new OVCAPIService();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);
 
  function filterPayload(payload, cookie) {
    const cookieSet = new Set(
      cookie.map((item) => `${item.server}-${item.id}`)
    );

    return payload.filter(
      (item) =>
        !item.target_apps.some((server) =>
          cookieSet.has(`${server}-${item.id}`)
        )
    );
  }

  function filterPayloadByServer(payload, server) {
    return payload.filter((item) => item.target_apps.includes(server));
  }
  const handleNotification = async () => {
    if (location.pathname === "/") return;

    try {
      const response = await ovsService.sentnotificationData();
      if (response?.status === "success") {
        let payload = response?.notifications;
        const server = 'ovc'; 
        let user = "";
    
        if (localStorage.getItem("email")) {
          user = localStorage.getItem("email");
        } 
    
        payload = filterPayloadByServer(payload, server);
    
    
        const cookieValue = Cookies.get('user');
        let finalData = [];
    
        if (cookieValue) {
          payload = filterPayload(payload, JSON.parse(cookieValue));
          finalData = JSON.parse(cookieValue);
        }
    
        if (payload.length < 0) {
          return;
        }
    
        let message = [];
        payload.forEach((item) => {
          const cookieData = {
            server,
            id: item.id,
            user: user,
          };
    
          finalData.push(cookieData);
          message.push({ title: item.title, message: item.message });
        });
 
        if (finalData.length > 0) {
          Cookies.set('user', JSON.stringify(finalData), { expires: 1 });
        }
        if (message?.length > 0) {
          setIsModalOpen(true);
          setModalContent([...message]);
        }
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    handleNotification();
  }, [location]); 

  return (
    <>
    {isModalOpen && (<>
      <Notifcation isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} content={modalContent} />

    </>)}
    </>
  );
};

const Routers = () => {
   

  return (
    <div>
      
     
      <FloatingComponentProvider>
      <Router>
      <NotificationHandler /> 
        <Routes>
       
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/" element={<OvcNewLogin/>}/>
          <Route path="/dashboard" element={<RedirectBasedOnRole />} />
          <Route
            path="/template"
            create
            element={
              <Sidebar
                component={
                  <Suspense>
                    <Template />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/workflow-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <WorkFlowDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/inuranceList-uploaded"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <UploadListInsurance />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/ticket-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <UserManagementDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/create-template"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CreateTemplate />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/customer-loan-details"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <LoandetailsCustomer />
                  </Suspense>
                }
              />
            }
          />
            <Route
            path="/autodialer"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <AutoDialerDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/autodialer-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <AutoDialerDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/cet-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <AutoDialerDashboard />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/sales-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <AutoDialerDashboard />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/collection-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <AutoDialerDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/customer-loan-details"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <LoanDetailsTabs />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/welfare-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/voc-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/impact-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/welcome-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/csat-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/nps-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/insurance-cet-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CETCustomerList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/digital-leads-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <DigitalLeadsListing />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/preview-template"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PreviewTemplate />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/segment"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <Segment />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/create-segment"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CreateSegment />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/upload-segment"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <UploadSegment />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/workflow"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <Workflow />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/create-workflow"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CreateWorkFlow />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/preview-workflow"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PreviewWorkflow />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/preview-segment"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PreviewSegment />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/customer-profile"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerProfile />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/sanction-panel-secured-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerProfile />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/sanction-panel-unsecured-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerProfile />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/ticket-management"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <TicketManagement />
                  </Suspense>
                }
              />
            }
          /> 
           <Route
            path="/ticket-type"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <QueryManagement />
                  </Suspense>
                }
              />
            }
          />
            <Route
            path="/user-management"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <UserManagement />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/businessPrime-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <BusinessPrimeCustomerList />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/customer-details/:workflow"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <SalesworkflowCustomerDetails />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/deviceInventry-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <DeviceInventry />
                  </Suspense>
                }
              />
            }
          /> 
          <Route
            path="/businessPrime-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <BusinessPrimeDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/businessPrime-bulk-upload"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <BusinessPrimeBulkUpload />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/sales-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <SalesWorkflow />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/welcome-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <WelcomeWorkList />
                  </Suspense>
                }
              />
            }
          /> 
           <Route
            path="/hotlead-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <HotLeadsList />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/insurance-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <InsuranceDashboard />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/sahyog-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <SahyogDashboard />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/sahyog-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <SahogyCustomerList />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/insurance-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <InsuranceCustomerList />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/collection-predue-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PreduecollectionList />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/collection-postdue-customer-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PostduecollectionList />
                  </Suspense>
                }
              />
            }
          /> 
           <Route
            path="/missed-call"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <MissedCall />
                  </Suspense>
                }
              />
            }
          />
           <Route
            path="/customer-Details/:workflow/:customerId/:parentId/:leadId"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <SahogyCustomerDetails />
                  </Suspense>
                }
              />
            }
          />
          <Route

            path="/ovc-dashboard"
            element={
              <Sidebar
                component={
                  <Suspense fallback={<div><h2>🌀 Loading...</h2></div>}>
                 
                    <OVCDashboard />
                    </Suspense>
                 
                }
              />
            }
          />
          <Route
            path="/customer/:customerId/:parentId/:loanId/:leadId"

            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerDetails />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="sanction-panel-secured-list/sanction-panel/customer/:customerId/:parentId/:loanId/:leadId"

            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerDetails />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="sanction-panel-unsecured-list/sanction-panel/customer/:customerId/:parentId/:loanId/:leadId"

            element={
              <Sidebar
                component={
                  <Suspense>
                    <CustomerDetails />
                  </Suspense>
                }
              />
            }
          />
          <Route
           path="/digital-lead-details/:id/:mobile"

            element={
              <Sidebar
                component={
                  <Suspense>
                    <DigitalLeadDetails />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/partner-leads-list"
            element={
              <Sidebar
                component={
                  <Suspense>
                    <PartnerLeadsListing />
                  </Suspense>
                }
              />
            }
          />
        </Routes>
      </Router>
    </FloatingComponentProvider>
    </div>
    
  );
};

export default Routers;
